import { Injectable } from '@angular/core';
import { SourceSheet, TableConfig } from 'src/app/model';

@Injectable({
  providedIn: 'root'
})
export class PaymentsMetadataService {
  private isConfigLoaded = false;
  private config: TableConfig = {
    sheetType: SourceSheet.PaymentsMetadata,
    columnMappings: [],
  };

  constructor() {
    this.loadConfig();
  }

  private loadConfig() {
    if (!this.isConfigLoaded) {
      this.config.columnMappings = [
        { Key: 'ReturnName', DisplayName: 'ReturnName', Column: 'A' },
        { Key: 'TaxSchema', DisplayName: 'AbTaxSchema', Column: 'B' }
      ];
      this.isConfigLoaded = true;
    }
  }

  public getConfig(): TableConfig {
    this.loadConfig();
    return this.config;
  }
}